/**
 * @prettier
 * @flow
 */
import { FormHelperText } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormCardNumberField } from 'src/components/form/card-details/FormCardNumberField';
import { FormCvvField } from 'src/components/form/card-details/FormCvvField';
import { FormExpiryField } from 'src/components/form/card-details/FormExpiryField';
import { removeNulls } from 'src/utils/removeNulls';
import { translate } from 'src/utils/translate/translate';

export function FormCardDetailsField({ name, required }: Props) {
    const { errors } = useFormContext();

    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <Typography variant='overline' color='textSecondary'>
                    {translate('Card Details')}
                </Typography>
                <FormCardNumberField name={name} rules={{ required }} />
            </Grid>
            <Grid item xs={6}>
                <FormExpiryField name={name} rules={{ required }} />
            </Grid>
            <Grid item xs={6}>
                <FormCvvField name={name} rules={{ required }} />
            </Grid>
            <FormHelperText error>{removeNulls([errors[name]?.['cardNumber']?.message, errors[name]?.['expiry']?.message, errors[name]?.['cvv']?.message]).join(', ')}</FormHelperText>
        </Grid>
    );
}

type Props = {|
    name: string,
    required?: boolean,
|};
